<template>
  <div ref="toolTipWrapper"
       :class="['tool-tip-container', extraClasses]"
       :style="stylePosition">
    <div ref="toolTip" class="tool-tip-content">
      <div v-if="textLines" class="tool-tip-sections">
        <p v-for="text in textLines" v-html="text">{{text}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      coordinates: Object,
      extraClasses: String,
      htmlContent: [Array, String],
      textLines: Array,
      yIsBottom: Boolean,
      yOffset: [Array, String],
    },

    name: 'ToolTip',

    data() {
      return {
        stylePosition: '',
      }
    },

    methods: {
      calculateTopPosition() {
        this.$nextTick(() => {
          const x = this.calculateXPosition(),
            y = this.calculateYPosition()
          this.stylePosition = `left: ${x}px; top: ${y}px;`
        })
      },

      calculateXPosition() {
        const width = this.$refs.toolTip ? this.$refs.toolTip.offsetWidth : 0
        let x = this.coordinates.x
        x = this.coordinates.nudgeUpRight ? x + 5 : x
        return this.coordinates.pushDirection === 'left' ? x - width : x
      },

      calculateYPosition() {
        const height = this.$refs.toolTip ? this.$refs.toolTip.offsetHeight : 0
        let y = this.coordinates.y
        y = this.coordinates.nudgeUpRight ? y - 10 : y
        return this.yIsBottom ? y - height : y
      },
    },

    watch: {
      coordinates: function() {
        if (this.coordinates && this.textLines) { this.calculateTopPosition() }
      }
    }
  }
</script>

<style lang="sass">
  //
  //  tooltip
  //
  .report-graphs-section
    .tool-tip-container
      background-color: #FFFFFF
      border: 1px solid #128ff9
      font-size: 1.3rem
      line-height: 1.3
      padding: 0.25rem
      pointer-events: none
      position: absolute
      text-align: center
      z-index: 9

      .tool-tip-content
        min-height: 75px
        min-width: 20px

      p
        line-height: normal
        margin: 0
</style>